import { gql } from "@apollo/client";

export const ADDRESS_PATH_TYPES = gql`
  query AddressPathTypes($where: ReferentialWhereInput) {
    addressPathTypes(where: $where) {
      response
    }
  }
`;

export const ADDRESS_ZIP_CODE_CITY = gql`
  query addressZipCodeCity($where: ZipCodeCityWhereInput) {
    addressZipCodeCity(where: $where) {
      id
      city
      zipCode
    }
  }
`;

export const FRANCE_ADDRESS_ZIP_CODE_CITY = gql`
  query franceAddressZipCodeCity($where: ZipCodeCityWhereInput) {
    franceAddressZipCodeCity(where: $where) {
      response
    }
  }
`;

export const CAPENCY_ADDRESS = gql`
  query capencyAddressAutoComplete($where: CapencyAddressWhereInput) {
    capencyAddressAutoComplete(where: $where) {
      value
      label
      postalCode
      city
      street
      streetNumber
    }
  }
`;

export const GOV_ADDRESS_FRANCE = gql`
  query govAddressAutoComplete($where: GovAddressWhereInput) {
    govAddressAutoComplete(where: $where) {
      value
      label
      postalCode
      city
      street
      streetNumber
    }
  }
`;

export const POLYNESIE_CITIES = gql`
  query polynesieCities($where: ZipCodeCityWhereInput) {
    polynesieCities(where: $where) {
      response
    }
  }
`;

const referential = {
  ADDRESS_PATH_TYPES,
  ADDRESS_ZIP_CODE_CITY,
  FRANCE_ADDRESS_ZIP_CODE_CITY,
  CAPENCY_ADDRESS,
  GOV_ADDRESS_FRANCE,
  POLYNESIE_CITIES,
};

export default referential;
